import type { EmptyArray } from '@mntn-dev/utility-types'

export const isEmptyArray = <T>(array: T[]): array is EmptyArray => {
  return array.length === 0
}
